import * as Types from '../types-api.generated';

import { MomentOverviewFragment, MomentFragment, UserLightFragment, WorldOverviewFragment, WorldOverviewOnExhibition, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, TokenFragment, NftIdentifiersFragment, AuctionFragment, SaleFragment, SplitFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiMomentByIdVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type ApiMomentById = { moment: { id: number, name: string, description: string | null, worldId: number, posterUrl: string, startsAt: string, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } } | null };



export const ApiMomentByIdDocument = /*#__PURE__*/ `
    query MomentById($id: Int!) {
  moment: momentById(id: $id) {
    ...MomentOverviewFragment
  }
}
    ${MomentOverviewFragment}
${MomentFragment}
${UserLightFragment}
${WorldOverviewFragment}`;

export const useMomentById = <
      TData = ApiMomentById,
      TError = ClientError
    >(
      variables: ApiMomentByIdVariables,
      options?: Omit<UseQueryOptions<ApiMomentById, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiMomentById, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiMomentById, TError, TData>(
      {
    queryKey: ['MomentById', variables],
    queryFn: apiFetcher<ApiMomentById, ApiMomentByIdVariables>(ApiMomentByIdDocument, variables),
    ...options
  }
    )};

useMomentById.getKey = (variables: ApiMomentByIdVariables) => ['MomentById', variables];

export const useInfiniteMomentById = <
      TData = InfiniteData<ApiMomentById>,
      TError = ClientError
    >(
      variables: ApiMomentByIdVariables,
      options: Omit<UseInfiniteQueryOptions<ApiMomentById, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiMomentById, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiMomentById, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MomentById.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiMomentById, ApiMomentByIdVariables>(ApiMomentByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMomentById.getKey = (variables: ApiMomentByIdVariables) => ['MomentById.infinite', variables];


useMomentById.fetcher = (variables: ApiMomentByIdVariables, options?: RequestInit['headers']) => apiFetcher<ApiMomentById, ApiMomentByIdVariables>(ApiMomentByIdDocument, variables, options);
